"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * This converts each typography object we have in our theme
 * into a CSS class that we can then apply to our typography.
 */
var _default = function _default(theme) {
  return Object.keys(theme.typography).filter(function (tk) {
    return (0, _typeof2.default)(theme.typography[tk]) === 'object';
  }).reduce(function (obj, key) {
    obj[key] = theme.typography[key];
    return obj;
  }, {});
};

exports.default = _default;